import { Button, Paper, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { BackButton, ButtonGrid, Page } from '../../components'
import { locale } from '../../locale'
import { initializeAdmin } from '../../state/Firebase/operations'
import { createDeviceStart } from '../../state/SystemCache/actions'
import { useMoveMenuPage } from '../App/operations'
import CreateDeviceFormModalContainer from '../DeviceForm/CreateDeviceFormModal'
import DeviceFormModalContainer from '../DeviceForm/DeviceFormModal'
import YuatsuCreateDeviceFormModalContainer from '../YuatsuDeviceForm/CreateDeviceFormModal'
import YuatsuDeviceFormModalContainer from '../YuatsuDeviceForm/DeviceFormModal'
import NavBar from '../NavBarContainer'
import { categories } from '../../utils'
import { Category } from '../../types'
import { useAuth } from '../Auth/useAuth'
import DeviceListContainer from './DeviceListContainer'

function patchCategory(path: string): Category {
  if (path === 'ekiatsu') return 'yuatsu'
  return path as Category
}

function AdminDevicePage() {
  const dispatch = useDispatch()
  const moveMenu = useMoveMenuPage()

  const { category: path } = useParams<{ category: Category }>()

  if (!path) throw new Error('path is undefined')
  const category = patchCategory(path)
  const label = categories[category]

  React.useEffect(() => {
    dispatch(initializeAdmin())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Helmet>
        <title>端末紐付管理({label})</title>
      </Helmet>
      <NavBar />
      <Page>
        <Typography variant="h5">端末紐付管理({label})</Typography>
        <Paper>
          <ButtonGrid>
            <Button onClick={() => dispatch(createDeviceStart())}>
              <AddIcon />
              {locale.deviceEntity}の追加
            </Button>
            <BackButton onClick={moveMenu}>戻る</BackButton>
          </ButtonGrid>
          <DeviceListContainer category={category} />
        </Paper>
      </Page>
      {category !== 'yuatsu' && (
        <>
          <DeviceFormModalContainer />
          <CreateDeviceFormModalContainer category={category} />
        </>
      )}
      {category === 'yuatsu' && (
        <>
          <YuatsuCreateDeviceFormModalContainer />
          <YuatsuDeviceFormModalContainer />
        </>
      )}
    </div>
  )
}

const AdminDevicePageLogin = () => {
  const res = useAuth()

  if (res.loading && res.Loader) return <res.Loader />
  if (!res.login) return null
  return <AdminDevicePage />
}

export default AdminDevicePageLogin
